import { motion } from 'framer-motion';
import { Target, Eye, Heart } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const values = [
  {
    icon: <Target className="w-6 h-6" />,
    title: 'Mission',
    description: 'To empower businesses with accessible financial solutions and government benefits, enabling sustainable growth and economic development.'
  },
  {
    icon: <Eye className="w-6 h-6" />,
    title: 'Vision',
    description: 'To be the most trusted financial consultancy firm in India, known for integrity, expertise, and client success in subsidy and finance advisory.'
  },
  {
    icon: <Heart className="w-6 h-6" />,
    title: 'Values',
    description: 'Transparency, integrity, client-first approach, and commitment to excellence guide every interaction and decision we make.'
  }
];

export const AboutValues = () => (
  <section className="py-24" data-testid="values-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Our Foundation
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          The principles that guide our work and define our commitment to clients.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {values.map((value, index) => (
          <motion.div
            key={value.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Card className="h-full border border-slate-100 hover:border-[#00bcd4]/30 transition-colors bg-white">
              <CardContent className="p-8 text-center">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white mx-auto mb-6">
                  {value.icon}
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#0f172a] mb-4">
                  {value.title}
                </h3>
                <p className="text-[#64748b] text-sm leading-relaxed">
                  {value.description}
                </p>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
